import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Text from '../../../../component/text/Text';
import ColoredLine from '../../../../component/coloredLine/ColoredLine';
import Autocomplete from '../../../../component/autocomplete/Autocomplete';
import { BackButton, PrimaryButton, SecondaryButton } from '../../../../component/buttonComponent/ButtonComponent';
import GeofenceAlert from '../../../../component/notificationAlertModules/GeofenceAlert';
import AssetStatusAlert from '../../../../component/notificationAlertModules/AssetStatusAlert';
import SpeedingAlert from '../../../../component/notificationAlertModules/SpeedingAlert';
import BatteryStatusAlert from '../../../../component/notificationAlertModules/BatteryStatusAlert';
import EVRangeAlert from '../../../../component/notificationAlertModules/EVRangeAlert';
import EVChargingAlert from '../../../../component/notificationAlertModules/EVChargingAlert';
import EVBatteryTemperatureAlert from '../../../../component/notificationAlertModules/EVBatteryTemperatureAlert';
import EVBatteryStateOfHealth from '../../../../component/notificationAlertModules/EVBatteryStateOfHealth';
import './NotificationConfigurationDetails.css';

const NotificationConfigurationDetails = () => {
    const location = useLocation();
    const detailsRow = location.state ? location.state.row : null;
    const bboxPolygon = location.state ? location.state.bboxPolygon : null;
    const navigate = useNavigate();
    const [disableMainButton, setDisableMainButton] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [inputLoading, setInputLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [selectionList, setSelectionList] = useState({});
    const [dropDownLoading, setDropDownLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [alertTypeList, setAlertTypeList] = useState([
        {
            id: 0,
            name: 'Geofence',
            value: 'Geofence',
        },
        {
            id: 1,
            name: 'Asset Status',
            value: 'AssetStatus',
        },
        {
            id: 2,
            name: 'Speeding',
            value: 'Speeding',
        },
        {
            id: 3,
            name: 'Battery Status',
            value: 'BatteryStatus',
        },
        {
            id: 4,
            name: 'EV Range',
            value: 'EvRange',
        },
        {
            id: 5,
            name: 'EV Charging',
            value: 'EvCharging',
        },
        {
            id: 6,
            name: 'EV Battery Temperature',
            value: 'EvBatteryTemperature',
        },
        {
            id: 7,
            name: 'Ev Battery State of Health',
            value: 'EvBatteryStateOfHealth',
        },
    ]);

    const backToSearch = () => {
        navigate('/notifications/configuration', { replace: true });
    };

    const backButton = () => {
        navigate('/notifications/configuration', { replace: true });
    };

    const switchBody = (value) => {
        switch (value) {
            case 0:
                return (
                    <>
                        <GeofenceAlert detailsRow={detailsRow} bboxPolygon={bboxPolygon} selectionList={selectionList} />
                    </>
            );
            case 1:
                return (
                    <>
                        <AssetStatusAlert detailsRow={detailsRow} selectionList={selectionList} />
                    </>
            );
            case 2:
                return (
                    <>
                        <SpeedingAlert detailsRow={detailsRow} selectionList={selectionList} />
                    </>
            );
            case 3:
                return (
                    <>
                        <BatteryStatusAlert detailsRow={detailsRow} selectionList={selectionList} />
                    </>
                );
            case 4:
                return (
                    <>
                        <EVRangeAlert detailsRow={detailsRow} selectionList={selectionList} />
                    </>
                );
            case 5:
                return (
                    <>
                        <EVChargingAlert detailsRow={detailsRow} selectionList={selectionList} />
                    </>
                );
            case 6:
                return (
                    <>
                        <EVBatteryTemperatureAlert detailsRow={detailsRow} selectionList={selectionList} />
                    </>
                );
            case 7:
                return (
                    <>
                        <EVBatteryStateOfHealth detailsRow={detailsRow} selectionList={selectionList} />
                    </>
                );
            default:
                return (
                    <></>
                );
        }
    };

    useEffect(() => {
        if (location.state) {
            const selected = alertTypeList.filter((x) => x.name.toLowerCase() === location.state.row.alertType.toLowerCase());
            setSelectionList(selected[0]);
            setSelectedOption(selected[0].id);
        }
    }, []);

    return (
        <div className="notification-config-details-container">
            <div className="notification-config-details-back-button">
                <BackButton label="Back to alert configurations" btnClickBack={backToSearch} color="#FFFFFF" />
            </div>
            <div className="notification-config-details-header">
                <div className="notification-config-details-container-button">
                    <Text
                      text="Create alert"
                      weight="600"
                      size="1.125rem"
                      color="#101828"
                    />
                    {/* <div className="notitfication-config-details-button">
                        <SecondaryButton label="Cancel" onClickFunction={backButton} />
                        <PrimaryButton label={detailsRow ? 'Update' : 'Create'} onClickFunction={finalCreateButton} disable={!disableMainButton} loading={btnLoading} />
                    </div> */}
                </div>
                <ColoredLine />
                <div className="notification-config-body-container">
                    <div className="notification-config-body-text">
                        Alert Type
                    </div>
                    <Autocomplete
                      component="notificationDetails"
                      width="32rem"
                      list={alertTypeList}
                      selectionList={selectionList}
                      setSelectionList={setSelectionList}
                      text="Select alert type"
                      isAlertSelector
                      isImage={false}
                      inputValue={inputValue}
                      stateInputValue={setInputValue}
                      selectedOption={selectedOption}
                      setSelectedOption={setSelectedOption}
                      dropDownLoading={dropDownLoading}
                      setDropDownLoading={setDropDownLoading}
                      loadAsset={inputLoading}
                      disable={!!detailsRow}
                    />
                </div>
            </div>
            <div className="notification-config-details-body">
                {switchBody(selectionList.id)}
            </div>
        </div>
    );
};

export default NotificationConfigurationDetails;
